import React, {Fragment, useState} from "react";

import {deleteData, setData, setNewData} from "services/Indicators.service";
import {i18n} from "translate/i18n";

import {toast} from "react-toastify";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {useParams} from "react-router";
import Editor from "../Editor";
import {swalQuestion} from "../Swal";
import {setLog} from "../../services/Logs.service";
import {useUser} from "../../store/providers/app";
import {getCommentsById} from "../../services/Comments.service";
import {groupBy} from "../../utils/actions";

import CommentTable from "../Comments/commentTable";
import Format from "../../utils/format";

export const EditableTranslate = ({table}) => {

    const {id} = useParams()

    const {user} = useUser()

    const [newHeader, setNewHeader] = useState(table?.headers);
    const [newRows, setNewRows] = useState(table?.rows);
    const [title, setTitle] = useState(table?.titulo)
    const [footer, setFooter] = useState(table?.footer)
    const [totalComments, setTotalComments] = useState(0)

    const queryClient = useQueryClient();

    const {isFetching} = useQuery(["comments_table", table.id],
        () => {
            return id && getCommentsById(id)
        }, {
            onSuccess: (response) => {

                if (response) {
                    let commentsIndicator = groupBy(response, 'type_input')

                    const total = commentsIndicator[`table-${table.id}`]?.filter(item => item.resolved === 0).length

                    setTotalComments(total)

                }
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false
        }
    )


    const editInputHeader = (value, index, position) => {
        const header = [...newHeader];

        header[index][position] = {...header[index][position], value: value.target.value}
        setNewHeader(header)
    }

    const editInputRow = (value, value_format, index, position) => {
        const rows = [...newRows];
        rows[index][position] = {...rows[index][position], value: value, value_format: value_format}

        setNewRows(rows)
    }

    const formatColumn = (newValue, { action }, position) => {
        const rows = [...newRows];
        rows.map(item =>
            item[position].unit = newValue.value
        )
        setNewRows(rows)
    }


    const userMutations = useMutation(async (data) => {
            return setData(table.id, data)
        }, {
            onSuccess: (res) => {
                setLog({
                    'title': 'UPDATE_TABLE_INDICATOR',
                    'description': 'Tabela atualizada',
                    'username': user.username,
                    'indicator_id': id,
                }).then((response) => {});

                toast.success(i18n.t('success.editData'))
                queryClient.invalidateQueries(['tables_indicator', id])
            },
            onError: (err) => {
                toast.error(i18n.t('error.badRequest'));
            }
        }
    )

    const saveData = () => {
        let data = {
            'title': title,
            'rows': newRows,
            'headers': newHeader,
            'footer': footer ? footer : ''
        }


        if (table.id) {
            swalQuestion(`<b>${i18n.t('questions.editData')}</b>`).then(res => {
                if (res.isConfirmed) {
                    userMutations.mutate(data)
                }
            })
        } else {

            table['title'] = title
            table['footer'] = footer

            setNewData(table).then(response => {
                setLog({
                    'title': 'CREATE_TABLE_INDICATOR',
                    'description': 'Criada nova tabela',
                    'username': user.username,
                    'indicator_id': id,
                }).then((response) => {});
                toast.success('Tabela criada com sucesso!')
            })
            queryClient.invalidateQueries(['tables_indicator', id])
        }

    }

    const getDataFooter = (input, text) => {
        setFooter(text)
    }

    const handleDelete = (id) => {
        swalQuestion(`<b>Deseja excluir esta tabela?</b>`).then(res => {
            if (res.isConfirmed) {
                deleteTableMutations.mutate(id)
            }
        })
    }

    const deleteTableMutations = useMutation(async (id) => {
            return deleteData(id)
        }, {
            onSuccess: (res) => {
                toast.success('Tabela excluida com sucesso!')
                queryClient.invalidateQueries(['tables_indicator', id])
            },
            onError: (err) => {
                toast.error(i18n.t('error.badRequest'));
            }
        }
    )

    return (
        <>
            <div className="row m-0">

                <div className="col-12  border-bottom px-3">
                    <div className="my-3">
                        <span className="form-label">Título</span>
                        <input className="form-control" value={title ? title : ''} onChange={(e) => setTitle(e.target.value)}/>
                    </div>
                </div>
            </div>

            <div className="table-responsive m-3">

                <table className="table table-bordered align-middle">
                    { newHeader?.map((head, index) => head.length > 0 && (
                        <Fragment key={index}>
                            <thead key={index}>
                                <tr>
                                    { head?.map((column, position) =>
                                        <th className={`p-1 ${position === 0 && 'table-custom'}`} key={position}>
                                            <textarea value={column.value ? column.value : ''}
                                                      className="form-control border-0 fw-bolder" rows="2"
                                                      onChange={(e) => editInputHeader(e, index, position)}/>

                                        </th>
                                    )}
                                </tr>
                            </thead>
                        </Fragment>
                    ))}

                    <tbody>
                        { newRows.map((row, index) =>
                            <tr key={index}>
                                { row.map((line, position) =>
                                    <td className="text-end" key={position} style={{"minWidth": "200px"}}>
                                        { position === 0 ?
                                            <Format
                                                    value={line?.value}
                                                    unit={line?.unit}
                                                    editInputRow={editInputRow}
                                                    rowPosition={index}
                                                    position={position}
                                            />
                                            : line.value
                                        }
                                    </td>
                                )}
                            </tr>
                        )}
                    </tbody>
                </table>

            </div>

            <div className="p-3">
                <label className="form-label">{i18n.t('stage.footer')}</label>
                <Editor
                    handleChange={getDataFooter}
                    data={footer}
                    name="notas_de_rodape"
                />
            </div>

            <div className="accordion p-3" id="accordionComment">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                            Comentários <span className="badge text-bg-danger ms-2 bg-danger">{ totalComments ? totalComments : 0 }</span>
                        </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionComment">
                        <div className="accordion-body">
                            <CommentTable data={{'param': `table-${table.id}`, 'label': 'table'}} tableId={table.id} indicatorId={table.tableable_id}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <div className="d-flex gap-2 bg-light border-top justify-content-end p-3">
                        <button type="button" className="btn btn-success px-5 py-2"
                                onClick={() => saveData()}>{i18n.t('buttons.save')}</button>

                    </div>
                </div>
            </div>
        </>
    )
}
